import React from 'react';

import AirlineLogo from '../../Airline/AirlineLogo/AirlineLogo';
import TextLight from '../TextLight/TextLight';
import Divider from '../../../UI/Divider/Divider';

import moment from 'moment';

import classes from './FlightDetailsRoundTripTuple.scss';

const FlightDetailsRoundTripTuple = (props) => {

    const { 
        ac,
        airline, 
        flightNumberInitial, 
        flightNumberDigit,
        aircraftName,
        dTime,
        duTime,
        aTime,
        originCity,
        destinationCity,
        via,
        origin,
        destination,
        departureTerminal,
        arrivalTerminal,
        baggage,
        adt,
        ddt,
        meal
    } = props;
    
    return (
        <React.Fragment>
            <div className={`${classes.InfoRow} mt-2 mb-4`}>
                <TextLight><AirlineLogo airlineCode={ac} /> {airline} {flightNumberInitial} {flightNumberDigit}</TextLight>
                <p className="u-flex align-items-center u-fontWeightRegular u-fontSize11 u-textColorLight">{aircraftName}</p>
            </div>
            <div className={`mb-2`}>
                <div className={`u-flex justify-content-between align-items-center mb-5`}>
                    <div className="u-flex f-column">
                        <span className="u-fontSize16 u-textColorDark u-fontWeightMedium u-textAlignLeft u-lineHeight1">{dTime}</span> 
                        <span className="u-fontSize13 u-textColorDark u-fontWeightRegular">{moment(ddt).format("DD MMM, ddd")}</span>
                    </div>
                    <span className={`u-fontSize13 u-textColorDark u-fontWeightRegular`}>{duTime}</span> 
                    <div className="u-flex f-column">
                        <span className="u-fontSize16 u-textColorDark u-fontWeightMedium u-textAlignRight u-lineHeight1">{aTime}</span>
                        <span className="u-fontSize13 u-textColorDark u-fontWeightRegular">{moment(adt).format("DD MMM, ddd")}</span>
                    </div>
                </div>
                <div className={`u-flex justify-content-between align-items-center`}>
                    <span className={`u-fontSize13 u-fontWeightMedium u-textColorDark u-width100 u-textAlignLeft`}>{originCity}</span>
                    {via}
                    <span className={`u-fontSize13 u-fontWeightMedium u-textColorDark u-width100 u-textAlignRight`}>{destinationCity}</span>
                </div>
                <div className={`u-flex justify-content-between align-items-center`}>
                    <span className={`u-fontWeightRegular u-textColorNormal u-fontSize13`}>{origin} | {departureTerminal}</span>
                    <span className={`u-fontWeightRegular u-textColorNormal u-fontSize13`}>{destination} | {arrivalTerminal}</span>
                </div>
            </div>
            <div>
                <Divider type='normal'/>
            </div>
            <div className={`${[classes.InfoRow, classes.InfoRowBottom].join(' ')} mt-2 mb-2`}>
                <h5 className={`u-flex align-items-center u-fontWeightRegular u-fontSize13 u-textColorLight u-textCapitalize`}>Check-In baggage {baggage}</h5>
                <h5 className={`u-flex align-items-center u-fontWeightRegular u-fontSize13 u-textColorLight u-textCapitalize`}>{meal === '' ? 'Paid meal' : 'Free meal'}</h5>
            </div>
            {baggage === "Hand Baggage only" ? <div className="mt-1">
                    <p className={`u-backgroundColorHandBaggage u-flexCenter u-textColorDark u-textAlignCenter u-relative u-fontSize11 u-borderRadius4 u-height24`}>
                    Special&nbsp;<span className={`u-fontWeightMedium`}>Hand Baggage only fare</span>&nbsp;provided by the airlines.
                    </p>
                </div> : null}
        </React.Fragment>
    );
}

export default FlightDetailsRoundTripTuple;


// WEBPACK FOOTER //
// ./src/components/Flight/FlightDetailsRoundTrip/FlightDetailsRoundTripTuple/FlightDetailsRoundTripTuple.js